import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import minifyTheme from 'minify-css-string'
import ja from 'vuetify/src/locale/ja'

const LRU = require('lru-cache')
const themeCache = new LRU({
  max: 10,
  ttl: 1000 * 60 * 60 // 1 hour
})

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  breakpoint: {
    mobileBreakpoint: 1025,
    thresholds: {
      xs: 0,
      sm: 577,
      md: 1025,
      lg: 1441,
      xl: 1921,
      ul: 2561
    }
  },
  theme: {
    options: { minifyTheme, themeCache }
  }
})
